import { render, staticRenderFns } from "./CustomerInvoicesView3.vue?vue&type=template&id=d0fddb60&scoped=true&"
import script from "./CustomerInvoicesView3.vue?vue&type=script&lang=js&"
export * from "./CustomerInvoicesView3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0fddb60",
  null
  
)

export default component.exports